module.exports = __webpack_public_path__ + "static/media/img-tuberia-04.3ae40b0c.jpg";